// extracted by mini-css-extract-plugin
export default {"tabs":"MonitoringIndicatorsTab_tabs__tz8R8","tab":"MonitoringIndicatorsTab_tab__424GJ","tabDesc":"MonitoringIndicatorsTab_tabDesc__vdeVl"};